<script>
import appConfig from "@/app.config";
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {Loader},
  data() {
    return {

      updating: true,
      movsData: [],


    }
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  mounted() {
    console.log('mounted trk_ext_ped')


    api.get(`${getBaseUrl()}api/movtrkext`, {
      params: {
        cnpj: '12345678900'
      }
    }).then((res) => {
      console.log("then axios get mov track");
      console.log(res.data);
      this.movsData = res.data[0]

      this.updating = false
    });


  },
  methods: {

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },


  },

  page: {
    title: "tracking-externo-pedido",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },


}

</script>
<template>
  <div>

    <section class="my-5 pt-sm-5">
      <div class="container">

        <Loader v-if="updating" style="min-height: 300px;">
        </Loader>

        <div class="row" v-if="!updating">

          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="text-center mb-5">
                <h4>Últimos Pedidos</h4>
                <p
                    class="text-muted"
                >Para mais detalhes, clique sobre o pedido</p>
              </div>
            </div>
          </div>

          <div class="row">



            <div v-for="data in movsData" :key="data.id" class="col-xl-3 col-md-6">
              <div class="card plan-box">
                <div class="card-body p-4">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <h5>{{ formatDateTime(data.dtemissao) }}</h5>
                      <p class="text-muted">Nota Fiscal: {{data.codigo}}</p>
                    </div>
                    <div class="ms-3">
                      <i :class="`bx bx-car h1 text-primary`"></i>
                    </div>
                  </div>
                  <div class="py-4">
                    <h2>
                      <sup>
                        <small>R$ </small>
                      </sup>
                      {{ formatDecimal(data.valorliq) }}
                      <span class="font-size-13">Líquido</span>
                    </h2>
                  </div>
                  <div class="text-center plan-btn">
                    <a
                        href="javascript: void(0);"
                        class="btn btn-primary btn-sm position-relative"
                    >Mais Detalhes</a>
                  </div>

                  <div class="plan-features mt-5">
                    <p>
                      <i class="bx bx-checkbox-square text-primary me-2"></i> Últimas Ocorrência
                    </p>
                    <p>
                      <i class="bx bx-checkbox-square text-primary me-2"></i> Últimas Ocorrência
                    </p>
                    <p>
                      <i class="bx bx-checkbox-square text-primary me-2"></i> Últimas Ocorrência
                    </p>
                    <p>
                      <i class="bx bx-checkbox-square text-primary me-2"></i> Últimas Ocorrência
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>



  </div>
</template>
